import React, { CSSProperties, useCallback } from "react";
import styled, { css } from "styled-components/macro";
import { fieldBase } from "../Form";
import checkImg from "./check.svg";

export interface InputProps extends fieldBase<boolean> {
  style?: CSSProperties;
  selected?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  selectedRadioColor?: string;
}

const Radio = styled.div<{
  selected: boolean;
  readOnly?: boolean;
  selectedRadioColor?: string;
}>`
  position: relative;
  background: #ffffff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  &:after {
    content: "";
    box-sizing: border-box;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  ${(props) =>
    props.selected
      ? css`
          &:after {
            background: ${props.selectedRadioColor || "rgba(9, 21, 38, 0.6)"};
          }
          border: 2px solid ${props.selectedRadioColor || "rgba(9, 21, 38, 0.6)"};
        `
      : css`
          &:after {
            background: transparent;
          }
          border: 2px solid rgba(9, 21, 38, 0.6);
        `}
  ${(props) => props.readOnly && `border: 2px solid transparent;`}
`;
const Input = styled.input`
  display: none;
`;
const Label = styled.label`
  display: flex;
`;
const Text = styled.div`
  margin-left: 8px;
  font-size: 16px;
  line-height: 22px;
`;
function RadioButton(props: React.PropsWithChildren<InputProps>) {
  const handleChange = useCallback(() => {
    if (props.readOnly) return;
    props.onChange?.(!props.value);
  }, [props.onChange, props.value, props.readOnly]);
  const onClick = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    props.onClick?.(e);
  };
  const selectedControl = props.value || false;
  return (
    <Label>
      <Input
        type="radio"
        onChange={handleChange}
        checked={selectedControl}
        onSelect={handleChange}
        hidden
        onClick={onClick}
      />
      <Radio
        readOnly={props.readOnly}
        selected={selectedControl}
        selectedRadioColor={props.selectedRadioColor}
      />
      <Text>{props.children}</Text>
    </Label>
  );
}

export default RadioButton;
